import * as THREE from "three";
import { to3Ds_Left, to3Ds_Right, to3Ds_Front, to3Ds_Back, to3Ds_Top, to3Ds_Bottom, getBoxZ } from "../shape/Intersect";
import { toXZ, toXY, toYZ } from "./Adapter";


/**
 * Calculates the PTB shape based on the given mesh, tubercle, candyle, ptbI, and ptbO.
 * @param {THREE.Mesh} mesh - The mesh to calculate the PTB shape from.
 * @param {THREE.Vector2} tubercle - The tubercle vector.
 * @param {THREE.Vector2} candyle - The candyle vector.
 * @param {THREE.Vector2} ptbI - The ptbI vector.
 * @param {THREE.Vector2} ptbO - The ptbO vector.
 * @returns {Array<THREE.Vector3>} An array of two Vector3 objects representing the vptI and vptO points.
 */
export function getShapePTB(mesh, tubercle, candyle, ptbI, ptbO){
  console.log("GetShapePTB");
  /*
  var [min_x, max_x, min_y, max_y] = getBoxZ(mesh, 0);
  const width_x = max_x - min_x;
  const width_y = max_y - min_y;
  const dist = Math.abs(tubercle.x - candyle.x);
  const w = dist * 2.370967742 + width_x * -0.283154122 - 30.724;
  const h = width_y * -0.899224806 + width_x * 0.462523 + 56.42377;
  console.log("width_x", width_x);
  console.log("width_y", width_y);
  console.log("dist", dist);
  */
  // 上記計算式にあてはめると、w=-5, h=6ぐらいになってしまう
  const w  = 20;
  const h  = 8;
  const cx = (ptbI.x + ptbO.x) / 2;
  const center = new THREE.Vector2(cx, 0);

  
  // var ptI = ellipse(center, w-4, h-4, 8);
  // // this is to draw straight line, 1.2 is just to modify parameter
  // ptI[2].y = ptI[1].y*1.2;
  // ptI[6].y = ptI[7].y*1.2;

  // innter curve /////////////////////////////////////
  var centerIn = new THREE.Vector2(ptbI.x, 0);
  var ptIn = ellipse(centerIn, 5, 5, 8);
  // extract the point id of ptIn from 2 to 6 to get half of the ellipse
  ptIn = ptIn.slice(2, 7);

  var centerOut = new THREE.Vector2(ptbO.x, 0);
  var ptOut = ellipse(centerOut, 5, 5, 8);
  // extract the point id of ptOut from 6 to 2 to get half of the ellipse
  ptOut = ptOut.slice(6, 9).concat(ptOut.slice(0, 3));
  
  var ptI = ptIn.concat(ptOut);
  // smooth
  ptI[0].x += 3;
  ptI[4].x += 3;
  ptI[5].x -= 3;
  ptI[9].x -= 3;
  ////////////////////////////////////////////////////



  // outer curve /////////////////////////////////////
  //var ptO = ellipse(center, w, h, 8);
  // this is to draw straight line, 1.2 is just to modify parameter
  // ptO[2].y = ptO[1].y*1.2;
  // ptO[6].y = ptO[7].y*1.2;

  centerIn = new THREE.Vector2(ptbI.x, 0);
  ptIn = ellipse(centerIn, 9, 9, 8);
  // extract the point id of ptIn from 2 to 6 to get half of the ellipse
  ptIn = ptIn.slice(2, 7);

  centerOut = new THREE.Vector2(ptbO.x, 0);
  ptOut = ellipse(centerOut, 9, 9, 8);
  // extract the point id of ptOut from 6 to 2 to get half of the ellipse
  ptOut = ptOut.slice(6, 9).concat(ptOut.slice(0, 3));
  
  var ptO = ptIn.concat(ptOut);
  // smooth
  ptO[0].x += 3;
  ptO[4].x += 3;
  ptO[5].x -= 3;
  ptO[9].x -= 3;
  ////////////////////////////////////////////////////

  // // Convert Vector2 to Vector3 to use THREE.CatmullRomCurve3 for smoothing curve
  // var ptI3 = [];
  // var ptO3 = [];
  // for(var i=0; i<ptI.length; i++){
  //   ptI3.push(new THREE.Vector3(ptI[i].x, ptI[i].y, 0));
  //   ptO3.push(new THREE.Vector3(ptO[i].x, ptO[i].y, 0));
  // }
  // // close curve
  // ptI3.push(new THREE.Vector3(ptI[0].x, ptI[0].y, 0));
  // ptO3.push(new THREE.Vector3(ptO[0].x, ptO[0].y, 0));

  // // Smooth the curve
  // var curveI = new THREE.CatmullRomCurve3(ptI3);
  // var curveO = new THREE.CatmullRomCurve3(ptO3);

  // // Get the points on the curve
  // ptI = curveI.getSpacedPoints(100);
  // ptO = curveO.getSpacedPoints(100);
  
  console.log(mesh)
  
  var vptI = to3Ds_Front(mesh, ptI, true);
  var vptO = to3Ds_Front(mesh, ptO, true);

  console.log(vptI)

  return [vptI, vptO];
}

/**
 * Calculates the shape counter based on the given mesh, tubercle and candyle.
 * @param {THREE.Mesh} mesh - The mesh to calculate the shape counter for.
 * @param {THREE.Vector2} tubercle - The tubercle vector.
 * @param {THREE.Vector2} candyle - The candyle vector.
 * @returns {Array<THREE.Vector3>} An array of 3D vectors representing the shape counter.
 */
export function getShapeCounter(mesh, tubercle, candyle){
  console.log("GetShapeCounter");
  /*
  var [min_x, max_x, min_y, max_y] = getBoxZ(mesh, 0);
  const width_x = max_x - min_x;
  const dist    = Math.abs(tubercle.x - candyle.x);
  const w       = dist * 4.967741935 + width_x * -0.265232975 - 88.7921147
  const h2      = dist * 5.483870968 + width_x * -0.465949821 - 68.22939068
  */
  //上記計算式にあてはめると、半径w, h2がマイナスになる可能性がある

  const h1  = 12;
  const h2  = 50;
  const w   = 30;
  const z = -12;
  const center = new THREE.Vector2(0, z);

  var ptI = ellipse(center, 10, 5, 8);
  var ptO1 = ellipse(center, w, h1, 8);
  var ptO2 = ellipse(center, w, h2, 8);

  var ptO = [];
  for(var i=0; i<5; i++){
    ptO.push(ptO1[i]);
  }
  for(var i=5; i<8; i++){
    ptO.push(ptO2[i]);
  }
  const vptI = to3Ds_Back(mesh, ptI, true);
  const vptO = to3Ds_Back(mesh, ptO, true);
  return [vptI, vptO];
}


export function getShapeTibia(mesh, tubercle, candyle, end, side){
  //console.log("tubercle", tubercle);
  //console.log("candyle", candyle);
  //console.log("end", end);
  //var [min_x, max_x, min_y, max_y] = getBoxZ(mesh, 0);
  //const width_x = max_x - min_x;
  //const height  = Math.abs(min_y);
  //const dist    = Math.abs(tubercle.x - candyle.x);
  //console.log("width_x", width_x);
  //console.log("height", height);
  //console.log("dist", dist);
  //const rC = (dist * -2.016129032 + width_x * 0.311827957 + 50.21505) / 2;
  //const rT = (dist * 0.64516129 + width_x * 0.082437276 + 1.286738) / 2;
  //const rE = (dist * 1.301278991 + height * -0.044364205 -2.75802) / 2;
  // 上記計算式にあてはめると、半径rがマイナスになる可能性がある

  const rC = 25;
  const rT = 20;
  const rE = 20;

  // console.log("rC", rC);
  // console.log("rT", rT);
  // console.log("rE", rE);
  const vptO = getShapeTibiaAAA(mesh, tubercle, candyle, end, rC, rT, rE, side);
  const vptI = getShapeTibiaAAA(mesh, tubercle, candyle, end, rC-5, rT-5, rE-5, side);
  return [vptI, vptO];
}

function getShapeTibiaAAA(mesh, tubercle, candyle, end, rC, rT, rE, side){
  var cC = circle(toYZ(candyle), rC, 8);
  var cT = circle(toXY(tubercle), rT, 8);
  var cE = circle(toXY(end), rE, 8);

  const vC = (side == 1) // right
              ? to3Ds_Left(mesh, cC, false)
              : to3Ds_Right(mesh, cC, false);
  const vT = to3Ds_Front(mesh, cT, false);
  const vE = to3Ds_Front(mesh, cE, false);

  const vptRn = [vT[0],vT[1],vT[2],vC[2],vC[1],vC[0],vC[7],vC[6],vT[5],vE[4],vE[5],vE[6],vE[7],vT[0]] // right
  const vptR = removeNullFromArray(vptRn);
  const vptLn = [vT[4],vT[3],vT[2],vC[2],vC[1],vC[0],vC[7],vC[6],vT[7],vE[0],vE[7],vE[6],vE[5],vT[4]]; // left
  const vptL = removeNullFromArray(vptLn);
  
  return (side == 1) ? vptR : vptL;
}

/**
 * Returns an array of two 3D points representing the inner and outer points of a fibula shape on the left side of a mesh.
 * @param {THREE.Mesh} mesh - The mesh to modify.
 * @param {THREE.Vector2} vpt - The vector representing the point on the viewport.
 * @returns {Array<THREE.Vector3>} An array of two 3D points representing the inner and outer points of a fibula shape on the left side of the mesh.
 */
export function getShapeFibulaLeft(mesh, vpt){
  const ptI = circle(vpt, 5, 8);
  const ptO = circle(vpt, 10, 8);
  const vptI = to3Ds_Left(mesh, ptI, true);
  const vptO = to3Ds_Left(mesh, ptO, true);
  return [vptI, vptO];
}

/**
 * Returns an array of two 3D points representing the inner and outer points of a fibula shape on the right side of a mesh.
 * @param {THREE.Mesh} mesh - The mesh to modify.
 * @param {THREE.Vector2} vpt - The vector representing the viewport position.
 * @returns {Array<THREE.Vector3>} An array of two 3D points representing the inner and outer points of a fibula shape on the right side of the mesh.
 */
export function getShapeFibulaRight(mesh, vpt){
  const ptI = circle(vpt, 5, 8);
  const ptO = circle(vpt, 10, 8);
  const vptI = to3Ds_Right(mesh, ptI, true);
  const vptO = to3Ds_Right(mesh, ptO, true);
  return [vptI, vptO];
}

//angle: 1:Front 2:Back 3:Top 4:Bottom 5:Right 6:Left
/**
 * Returns an array of two 3D points representing the inner and outer points of a shape on a mesh
 * @param {THREE.Mesh} mesh - The mesh to get the shape from
 * @param {THREE.Vector3} vpt - The center point of the shape in 3D space
 * @param {number} angle - The viewpoint of the shape (1-6)
 * @returns {Array<THREE.Vector3>} - An array containing two 3D points representing the inner and outer points of the shape
 */
export function getShapeUser(mesh, vpt, angle){
  // console.log("GetShapeUser", vpt, angle);
  const RADIUS_I = 5;
  const RADIUS_O = 10;

  var vptI = null;
  var vptO = null;

  if(angle == 6){
    const center = toYZ(vpt);
    const ptI = circle(center, RADIUS_I, 8);
    const ptO = circle(center, RADIUS_O, 8);
    vptI = to3Ds_Right(mesh, ptI, true);
    vptO = to3Ds_Right(mesh, ptO, true);
  }
  else if(angle == 5){
    const center = toYZ(vpt);
    const ptI = circle(center, RADIUS_I, 8);
    const ptO = circle(center, RADIUS_O, 8);
    vptI = to3Ds_Left(mesh, ptI, true);
    vptO = to3Ds_Left(mesh, ptO, true);
  }
  else if(angle == 1){
    const center = toXZ(vpt);
    const ptI = circle(center, RADIUS_I, 8);
    const ptO = circle(center, RADIUS_O, 8);
    vptI = to3Ds_Front(mesh, ptI, true);
    vptO = to3Ds_Front(mesh, ptO, true);
  }
  else if(angle == 2){
    const center = toXZ(vpt);
    const ptI = circle(center, RADIUS_I, 8);
    const ptO = circle(center, RADIUS_O, 8);
    vptI = to3Ds_Back(mesh, ptI, true);
    vptO = to3Ds_Back(mesh, ptO, true);
  }
  else if(angle == 3){
    const center = toXY(vpt);
    const ptI = circle(center, RADIUS_I, 8);
    const ptO = circle(center, RADIUS_O, 8);
    vptI = to3Ds_Top(mesh, ptI, true);
    vptO = to3Ds_Top(mesh, ptO, true);
  }
  else if(angle == 4){
    const center = toXY(vpt);
    const ptI = circle(center, RADIUS_I, 8);
    const ptO = circle(center, RADIUS_O, 8);
    vptI = to3Ds_Bottom(mesh, ptI, true);
    vptO = to3Ds_Bottom(mesh, ptO, true);
  }
  return [vptI, vptO];
}

//円周上の2D座標群を返す
// center: 中心座標(Vector2)
// r: 半径
// n: 等分数（360の約数が望ましい）
// pt: [Vector2]
/**
 * Generates an array of points that form a circle.
 * @param {THREE.Vector2} center - The center point of the circle.
 * @param {number} r - The radius of the circle.
 * @param {number} n - The number of points to generate.
 * @returns {THREE.Vector2[]} An array of points that form a circle.
 */
function circle(center, r, n){
  var pts = [];
  var theta = 360 / n;

  for(var i=0; i<n; i++){
    var deg = theta * i * Math.PI / 180;
    var x = center.x + r * Math.cos(deg);
    var y = center.y + r * Math.sin(deg);
    var pt = new THREE.Vector2(x, y);
    pts.push(pt);
  }
  return pts;
}

/**
 * Generates an array of points that form an ellipse.
 *
 * @param {Object} center - The center point of the ellipse.
 * @param {number} a - The horizontal radius of the ellipse.
 * @param {number} b - The vertical radius of the ellipse.
 * @param {number} n - The number of points to generate.
 * @returns {Array} An array of THREE.Vector2 points that form the ellipse.
 */
function ellipse(center, a, b, n){
  var pts = [];
  var theta = 360 / n;

  for(var i=0; i<n; i++){
    var deg = theta * i * Math.PI / 180;
    var x = center.x + a * Math.cos(deg);
    var y = center.y + b * Math.sin(deg);
    var pt = new THREE.Vector2(x, y);
    pts.push(pt);
  }
  return pts;
}

/**
 * Removes null values from an array.
 * @param {Array} array - The array to remove null values from.
 * @returns {Array} - The array without null values.
 */
function removeNullFromArray(array){
  var ret = [];
  array.forEach((item) => {
    if(item) ret.push(item);
  });
  return ret;
}